import React, { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { tone } from 'utils'
import { truncateStyles } from 'components/Truncate'
import { Flex } from 'components/Box'
import Caption from 'components/Caption'
import BaseHeading from 'components/Heading'
import { hexToRgba } from './utils'

export interface VersionItemHeadingProps {
  prefix?: ReactNode
  suffix?: ReactNode
  emphasize?: boolean
  className?: string
}

export const HeaderLine = styled.span<{
  emphasize?: boolean
  shrinkable?: boolean
}>`
  font-size: 0.75rem;

  ${({ shrinkable }) =>
    shrinkable
      ? css`
          ${truncateStyles};
          flex-shrink: 1;
        `
      : css`
          flex-shrink: 0;
        `}
`

export const HeadingContainer = styled(Flex)`
  ${truncateStyles};

  font-weight: ${({ theme }) => theme.fontWeights.medium};
  overflow: hidden;
`

HeadingContainer.defaultProps = {
  marginLeft: 4,
  alignItems: 'center',
}

export const VersionItemHeading: FC<VersionItemHeadingProps> = ({
  prefix,
  suffix,
  emphasize,
  children,
  className,
}) => (
  <HeadingContainer className={className}>
    {prefix && <HeaderLine>{prefix}</HeaderLine>}
    {prefix && <span>&nbsp;</span>}
    <HeaderLine emphasize={emphasize} shrinkable>
      {children}
    </HeaderLine>
    {suffix && <span>&nbsp;</span>}
    {suffix && <HeaderLine>{suffix}</HeaderLine>}
  </HeadingContainer>
)

export const HeadingSpace = styled(BaseHeading.H5).attrs({
  overflow: 'ellipsis',
})`
  color: ${({ theme }) => theme.colors.text.dark.primary};
  flex: 0 1 auto;
  margin: 0;
  margin-left: 8px;
  display: inline-flex;
  overflow: auto;
`

export const versionHeadingContainerStyles = css`
  &.active {
    ${HeadingSpace}, ${/* sc-selector */ Caption}, ${HeaderLine} {
      color: ${({ theme }) => tone(4, theme.colors.orange)};
    }
  }

  &.disabled {
    ${HeadingSpace} {
      opacity: 0.5;
    }

    /*
     * This particular case was not described by the designers
     * And it shouldn't actually happen, but we want to be safe
     * if unexpected error or scenario happens
     */
    &.active {
      background-color: ${hexToRgba(0.2, '#edeeed')};
      ${HeadingSpace}, ${/* sc-selector */ Caption} ${HeaderLine} {
        color: ${({ theme }) => theme.colors.text.dark.base};
      }
    }
  }
`
